import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { FormSectionProvider } from './FormSection.Context/FormSection.Context.es.js';
import { FormSectionDescription } from './FormSection.Description/FormSection.Description.es.js';
import { FormSectionDivider } from './FormSection.Divider/FormSection.Divider.es.js';
import { FormSectionElements } from './FormSection.Elements/FormSection.Elements.es.js';
import { FormSectionLabel } from './FormSection.Label/FormSection.Label.es.js';
import { FormSectionRow } from './FormSection.Row/FormSection.Row.es.js';
import { FormSectionTitle } from './FormSection.Title/FormSection.Title.es.js';

const FormSection = ({ className, children })=>{
    return jsx(FormSectionProvider, {
        children: jsx("div", {
            className: classNames('cb-form-section', className),
            children: children
        })
    });
};
FormSection.displayName = 'FormSection';
FormSection.Row = FormSectionRow;
FormSection.Label = FormSectionLabel;
FormSection.Title = FormSectionTitle;
FormSection.Description = FormSectionDescription;
FormSection.Elements = FormSectionElements;
FormSection.Divider = FormSectionDivider;

export { FormSection, FormSection as default };
//# sourceMappingURL=FormSection.es.js.map
